<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 95.66 122.72"
    width="24px"
    height="24px"
    class="svg-icon"
  >
    <path
      class="a"
      d="M106.44,48.47a4,4,0,0,0-4,4v57a5.92,5.92,0,0,1-5.91,5.91H31.47a5.92,5.92,0,0,1-5.91-5.91V18.54a5.92,5.92,0,0,1,5.91-5.91H60a4,4,0,1,0,0-8H31.47A13.93,13.93,0,0,0,17.56,18.54v90.92a13.93,13.93,0,0,0,13.91,13.91H96.53a13.93,13.93,0,0,0,13.91-13.91v-57A4,4,0,0,0,106.44,48.47Z"
      transform="translate(-17.56 -2.63)"
    />
    <path
      class="a"
      d="M112.41,8.12V8.05a6.86,6.86,0,0,0-.14-.79.83.83,0,0,0,0-.15,6.3,6.3,0,0,0-.25-.77h0a7.14,7.14,0,0,0-.37-.73l-.09-.14a7,7,0,0,0-.46-.65h0c-.17-.19-.35-.38-.53-.55l-.14-.13a5.61,5.61,0,0,0-.62-.47l0,0a7.08,7.08,0,0,0-.66-.38l-.15-.06a5.9,5.9,0,0,0-1.51-.47l-.19,0a7,7,0,0,0-.8-.06H84.14a6,6,0,1,0,0,12H92L76.84,29.75a6,6,0,1,0,8.48,8.48l15.12-15.11v7.19a6,6,0,1,0,12,0V8.63C112.44,8.46,112.42,8.29,112.41,8.12Z"
      transform="translate(-17.56 -2.63)"
    />
  </svg>
</template>

<script>
export default {
  name: "icon-copy-list"
};
</script>

<style scoped></style>
